'use client';

import { Image } from '@ahafood/ui/components/image';
import React from 'react';

const icons = [
  {
    '--size': '60px',
    '--x': '10vw',
    '--duration': '18s',
    '--delay': '-2s',
    '--drift': '4vw',
    '--rotation': '-20deg',
  },
  {
    '--size': '100px',
    '--x': '25vw',
    '--duration': '22s',
    '--delay': '-8s',
    '--drift': '-6vw',
    '--rotation': '30deg',
  },
  {
    '--size': '60px',
    '--x': '40vw',
    '--duration': '28s',
    '--delay': '-12s',
    '--drift': '8vw',
    '--rotation': '-10deg',
  },
  {
    '--size': '110px',
    '--x': '60vw',
    '--duration': '25s',
    '--delay': '-5s',
    '--drift': '-10vw',
    '--rotation': '25deg',
  },
  {
    '--size': '50px',
    '--x': '80vw',
    '--duration': '20s',
    '--delay': '-15s',
    '--drift': '5vw',
    '--rotation': '-35deg',
  },
  {
    '--size': '90px',
    '--x': '90vw',
    '--duration': '26s',
    '--delay': '-20s',
    '--drift': '-8vw',
    '--rotation': '15deg',
  },
  {
    '--size': '65px',
    '--x': '5vw',
    '--duration': '30s',
    '--delay': '-25s',
    '--drift': '10vw',
    '--rotation': '-25deg',
  },
];

const PromoIcons = () => {
  return (
    <div className="promo-icons-container">
      <style>
        {`
          .promo-icons-container {
            position: absolute;
            inset: 0;
            pointer-events: none;
            overflow: hidden;
            z-index: 1;
          }

          .promo-icon {
            position: absolute;
            will-change: transform, opacity;
            animation: fall linear infinite;
            top: -150px; /* Start above the screen */
            width: var(--size);
            height: var(--size);
            left: var(--x);
            animation-duration: var(--duration);
            animation-delay: var(--delay);
          }

          @keyframes fall {
            0% {
              transform: translateY(0) rotate(calc(var(--rotation) * -1));
              opacity: 0;
            }
            10% {
              opacity: 0.8;
            }
            50% {
              transform: translateY(50vh) rotate(calc(var(--rotation) * 1.5));
              opacity: 1;
            }
            90% {
              opacity: 0.5;
            }
            100% {
              transform: translateY(100vh) rotate(calc(var(--rotation) * 2));
              opacity: 0;
            }
          }
        `}
      </style>
      {icons.map((style, index) => (
        <div
          key={index}
          className="promo-icon"
          style={style as React.CSSProperties}
        >
          <Image
            src="/static/images/promo.webp" // Assuming you will add the image to public/static/icons
            alt="Promo Tag"
            width={parseInt(style['--size'], 10)}
            height={parseInt(style['--size'], 10)}
            className="object-contain"
          />
        </div>
      ))}
    </div>
  );
};

export default PromoIcons;
